import { render } from "./AddressMatchTool.vue?vue&type=template&id=3108aef7&scoped=true"
import script from "./AddressMatchTool.vue?vue&type=script&lang=js"
export * from "./AddressMatchTool.vue?vue&type=script&lang=js"

import "./AddressMatchTool.vue?vue&type=style&index=0&id=3108aef7&scoped=true&lang=css"
import "./AddressMatchTool.vue?vue&type=style&index=1&id=3108aef7&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3108aef7"]])

export default __exports__